import React from 'react'
import { Route } from 'react-router'
import { createReducer } from '@reduxjs/toolkit'
import DiagramView from './diagram_view'

export const reducer = createReducer({}, () => {})

export const routes = (
  <Route path="docs">
    <Route path="diagram">
      <Route index element={<DiagramView />} />
      <Route path=":doc_type" element={<DiagramView />} />
    </Route>
  </Route>
)

